<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" :to="{ name : 'Dashboard'}">
      <img class="logo-fif" src="../assets/images/logo-h-small.png" alt="">
      <img class="logo-fif-minimized" src="../assets/images/favicon-logo-inergi.png" alt="">
    </CSidebarBrand>
    <CSidebarNav>
      <CSidebarNavItem
        name="Dashboard"
        icon="cil-home"
        :to="{ name: 'Dashboard'}"
      ></CSidebarNavItem>
      <CSidebarNavItem
        name="Profile"
        icon="cil-user"
        :to="{ name: 'Profile'}"
      ></CSidebarNavItem>
      <CSidebarNavItem
        name="Documentation"
        icon="cil-file"
        :to="{ name: 'Documentation' }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        name="Download"
        icon="cil-cloud-download"
        :to="{ name: 'Download' }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        class="mt-auto bg-red"
        name="Logout"
        icon="cil-account-logout"
        @click.native="showLogoutModal = true"
      ></CSidebarNavItem>
      <CSidebarMinimizer
        class="d-md-down-none"
        @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
      />
    </CSidebarNav>
    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true">
      <div slot="header"><h5>{{modalTitle}}</h5></div>
      <div class="">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
    <CModal color="primary"
      :show.sync="showLogoutModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>Logout</h5></div>
      <div class="">
        Anda yakin ingin logout ?
      </div>
      <div slot="footer">
        <CButton size="lg" class="mr-2" color="danger" @click="showLogoutModal = false">Batal</CButton>
        <CButton size="lg" class="mr-2" color="primary" @click="logout()">OK</CButton>
      </div>
    </CModal>
  </CSidebar>
</template>

<script>
export default {
  name: 'TheSideBar',
  data(){
    return {
      modalTitle: 'Error',
      errorLabel: 'System Error',
      showErrorModal: false,
      showLogoutModal: false,
    }
  },
  methods: {
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.modalTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      this.$store.commit('set', ['isLoading', false]);
      this.showErrorModal = true;
    },
    logout(){
      this.$router.push({ name: 'Login' });
    }
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    },
    isLoggedIn(){
      if(sessionStorage.getItem('token')){
        return true;
      } else { return false }
    }
  }

}
</script>

<style>

</style>
